import { ProductCodes, Option, PromotionSurface } from '../pages/types';

export const PROMOTION_NAME_PREFIX_REGEX = /^\d{4}-\d{2} .+$/;

export function isValidPromotionName(name: string): boolean {
  const trimmedName = name.trim();
  if (trimmedName === '') {
    return false;
  }
  return PROMOTION_NAME_PREFIX_REGEX.test(trimmedName);
}

export function getStatusFromIsActiveOption(isActive: Option) {
  return isActive.value === 'true' ? 'ACTIVE' : 'INACTIVE';
}

export function mapSelectedProductIdsToCodes(
  selectedConditionalProductIds: Option[],
  products: ProductCodes[]
) {
  return selectedConditionalProductIds.map((productIdOption) => {
    const found = products.find((p) => p.id === productIdOption.value);
    if (!found) {
      throw new Error('Error: The conditional target product select does not exist!');
    }
    return found.code;
  });
}

export function buildFunnelPromotionRequest(params: {
  promotionName: string;
  bannerCopy: string;
  marketingSiteDesktopBannerCopy: string;
  marketingSiteMobileBannerCopy: string;
  status: string;
  startDate?: Date;
  endDate?: Date;

  selectedPromoProductOption: Option | null;
  selectedPaidProductOption: Option | null;

  quantity: string;
  paidQuantity: string;

  autoRenewIntoPaidSubscription: boolean;
  disclaimer: string;

  selectedConditionalProductIds: Option[];
  products: ProductCodes[];

  minimumSpendAmount: string;

  currency?: Option;
  eligibleCountry?: Option;
}) {
  const required_conditions_products = mapSelectedProductIdsToCodes(
    params.selectedConditionalProductIds,
    params.products
  );

  return {
    name: params.promotionName,
    banner_copy: params.bannerCopy,
    marketing_site_desktop_banner_copy: params.marketingSiteDesktopBannerCopy,
    marketing_site_mobile_banner_copy: params.marketingSiteMobileBannerCopy,

    status: params.status,
    promotion_type: 'ORDER',

    start_timestamp: params.startDate ?? undefined,
    end_timestamp: params.endDate ?? undefined,

    free_product_code: params.selectedPromoProductOption?.label ?? null,
    paid_product_code: params.selectedPaidProductOption?.label ?? null,

    quantity: params.quantity,
    paid_quantity: params.paidQuantity,

    auto_renew: !!params.autoRenewIntoPaidSubscription,
    disclaimer: params.disclaimer ?? null,

    required_conditions_products,
    minimum_order_gross_value_threshold_amount: params.minimumSpendAmount,

    currency: params.currency?.value,
    eligible_country: params.eligibleCountry?.value,

    promotion_surface: PromotionSurface.FUNNEL,
  };
}

export function buildPortalPromotionRequest(params: {
  promotionName: string;
  status: string;

  selectedPromoProductOption: Option | null;
  quantity: string;

  currency?: Option;
  eligibleCountry?: Option;

  eligibleOrderNumber: string;
  toastTitle: string;
  toastBody: string;
}) {
  return {
    name: params.promotionName,
    status: params.status,
    promotion_type: 'ORDER',

    free_product_code: params.selectedPromoProductOption?.label ?? null,
    quantity: params.quantity,

    currency: params.currency?.value,
    eligible_country: params.eligibleCountry?.value,

    promotion_surface: PromotionSurface.PORTAL,

    subscription_order_number: params.eligibleOrderNumber,
    toast_title_copy: params.toastTitle,
    toast_body_copy: params.toastBody,

    required_conditions_products: [], // backend requires it; PORTAL doesn't use it
  };
}
